import * as React from "react";
//import {getProjectTable2} from '../../utils/services/projectService';
import { useState, useContext, useRef } from "react";

import Button from "@mui/material/Button";
import { Box } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../utils/config";
import Geocode from "react-geocode";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { appCtx } from "../../utils/hooks/appContext";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../actions/snackbarActions";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { Grid } from "@mui/material";
import {
  GridToolbar,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
  getGridNumericOperators,
  getGridStringOperators,
  getGridDateOperators,
} from "@mui/x-data-grid";
import { GridFilterModel } from "@mui/x-data-grid";
import {
  useGridApiRef,
  gridFilterModelSelector,
  useGridApiContext,
} from "@mui/x-data-grid";

import {
  //GridRowModes,
  DataGrid,
  //GridToolbarContainer,
  //GridActionsCellItem,
} from "@mui/x-data-grid";
import { GridApi } from "@mui/x-data-grid";

import { filterContext } from "../../utils/hooks/filterContext";

Geocode.setApiKey(config.google_map_api_key);
Geocode.enableDebug();

const UsersTable = React.memo((props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const params = useParams();
  const [rows, setRows] = useState([]);
  const [rowModesModel, setRowModesModel] = useState({});
  /* const [filterModel, setFilterModel] = React.useState({
    items: [
      {
        columnField: "name",
        operator: "contains",
        value: "1",
      },
    ],
  });*/

  const { setProjectId } = useContext(appCtx);

  const { filterParameters, setFilterParameters } = useContext(filterContext);

  //const [loading, setLoading] = useState(true);
  const moment = require("moment");
  // const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  //const [items, setItems] = useState([]);
  function CustomToolbar() {
    return (
      <GridToolbarContainer
        className="MuiFormControl-root MuiTextField-root css-i44wyl"
        sx={{
          "&.css-17vbkzs-MuiFormControl-root-MuiTextField-root": {
            marginTop: "0px !important",
            backgroundColor: "yellow",
          },
        }}
      >
        <GridToolbarFilterButton />
      </GridToolbarContainer>
    );
  }

  const theme = useTheme();

  const RenderButtonOpen = (id) => {
    return (
      <Button
        onClick={(e) => {
          toProjectInfo(id);
        }}
        sx={{ color: theme.palette.secondary.main }}
      >
        {/*t("projectTableBtn.open")*/} Show projects
      </Button> //href='/project-item'
    );
  };

  const toProjectInfo = (id) => {
    //const ID = rows.filter((row) => row.id === id ? ID : row.id);
    console.log(id);
    //  setProjectId(id.row.id);
    console.log(id.row.id);
    //localStorage.setItem("id", id.row.id);
    window.scrollTo(0, 0);
    // navigate("/project-item", {
    //   state: {
    //   projectId: id.row.id,
    // projectNumber: id.row.projectNumber,
    // projectName: id.row.projectName,
    // },
    // });
    setFilterParameters({
      items: [
        {
          columnField: "ownerUserId",
          operator: "contains",
          operatorValue: "contains",
          value: id.row.id,
        },
      ],
    });
  };
  console.log(filterParameters);
  useEffect(() => {
    /* var filterIDs = [];
    if (visibleProjects !== undefined && visibleProjects.length !== 0) {
      console.log(visibleProjects);

      visibleProjects.map((item) => {
        console.log(item.id);
        filterIDs.push(item.id.toString());
      });
      console.log(filterIDs);
    }*/
    /* setFilterModel({
      items: [
        {
          columnField: filterParameters.columnField,
          operator: filterParameters.operator,
          operatorValue: filterParameters.operatorValue,
          value: filterParameters.operatorValue,
        },
      ],
    });*/
  }, [filterParameters]);

  const columns = [
    {
      field: "btnOpen",
      headerName: t("projectTableheaderName.open"),
      flex: 1,
      minWidth: 120,
      cellClassName: "actions",
      renderCell: RenderButtonOpen,
      headerClassName: "header-style",
      filterable: false,
    },
    {
      field: "firstName",
      headerName: "First name",
      flex: 3,
      minWidth: 100,
      editable: true,
      headerClassName: "header-style",
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "lastName",
      headerName: "Last name",
      type: "date",
      flex: 2,
      minWidth: 100,
      headerClassName: "header-style",
    },
    {
      field: "phoneNumber",
      headerName: "Phone number",
      flex: 4,
      editable: true,
      minWidth: 100,
      headerClassName: "header-style",
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "email",
      headerName: "Email",
      flex: 2,
      editable: true,
      minWidth: 100,
      headerClassName: "header-style",
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "id",
      headerName: "id",
      flex: 2,
      hidden: true,
      editable: false,
      minWidth: 100,
      headerClassName: "header-style",
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "role",
      headerName: "Role",
      flex: 2,

      editable: false,
      minWidth: 100,
      headerClassName: "header-style",
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
  ];
  //console.log(filterModel);
  const handleFilterChange = (newFilterModel) => {
    console.log(newFilterModel);
    // setFilterModel(newFilterModel);
    if (newFilterModel.items.length === 0) {
      console.log("Jeste 0");
      setFilterParameters({
        items: [
          {
            columnField: "id",
            operator: "contains",
            operatorValue: "contains",
            value: "",
          },
        ],
      });
    } else {
      setFilterParameters(newFilterModel);
    }
  };

  //const apiRef = useGridApiRef();

  const isFirstRender = useRef(true);
  /*useEffect(() => {
    console.log("poziva se funkcija gore");
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (
      items.length !== 0 &&
      items[0].value !== null &&
      items[0].value !== undefined
    ) {
      console.log(items);

      setTimeout(() => {
        props.refreshDashboardData(
          items[0].columnField,
          items[0].operatorValue,
          items[0].value
        );
      }, 2000);
    }
  }, [items]);*/
  return (
    /* return loading ? (
    <Box sx={{ width: "100%", height: "75vh" }}>
      <Stack
        spacing={1}
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Skeleton variant="rectangular" sx={{ width: "100%", height: "5vh" }} />
        <Skeleton variant="rectangular" sx={{ width: "100%", height: "5vh" }} />
        <Skeleton variant="rectangular" sx={{ width: "100%", height: "5vh" }} />
        <Skeleton variant="rectangular" sx={{ width: "100%", height: "5vh" }} />
      </Stack>
    </Box>
  ) : (*/
    <Grid
      container
      sx={{
        height: 500,
        width: "100%",
        "& .actions": {
          color: "text.secondary",
        },
        "& .textPrimary": {
          color: "text.primary",
        },
      }}
    >
      <Grid item xs={12}>
        <DataGrid
          rows={props.projects}
          columns={columns}
          components={{ Toolbar: GridToolbar }}
        />
      </Grid>
    </Grid>
  );
});

//ProjectsTable.whyDidYouRender = true;

export default UsersTable;
